  
  var logoIsBlack = false;
   
  function switchHeaderWhite() {
    switchLogo(true);
    $(".ayaq-home-link").attr("style", "color:black !important;");
    $(".ayaq-header-container").attr("style", "color:black; background-color: #FFFFFF !important;");
  };
  function switchHeaderTransparent() {
    switchLogo(false);
    $(".ayaq-home-link").attr("style", "color:white !important;");
    $(".ayaq-header-container").attr("style", "color:white; background-color: rgba(150, 150,150, 0.5);");
  };
  
  window.updateHeaderIconColors = function() {
    var isIndex = (typeof shop_template !== 'undefined' && shop_template === 'index');
    var isBlack = isIndex ? logoIsBlack : true;
    $('.icon-hamburger').css('color', isBlack ? '#000000 !important' : '#FFFFFF');
    $(".header__icons .icon").attr("style", isBlack ? 'color:#000000 !important' : 'color:#FFFFFF !important');
    $(".fa-map-marker-alt").attr("style", isBlack ? 'color:#000000 !important; font-size:22px; padding:0px 20px 0px 0px;' : 'color:#FFFFFF !important; font-size:22px; padding:0px 20px 0px 0px;');
    $(".header-partnershops").attr("style", isBlack ? 'color:#000000 !important; padding-top:10px;' : 'color:#FFFFFF !important; padding-top:10px;');
  };

  function switchLogo(isBlack){
    if ((isBlack && logoIsBlack) || (!isBlack && !logoIsBlack)) return;
    logoIsBlack = isBlack;
    var logo = isBlack ? logoBlack : logoWhite;
    $('#ayaq_logo').attr('src', logo);
    $('#ayaq_logo').attr('srcset', logo);
    window.updateHeaderIconColors();
  }
  document.addEventListener("DOMContentLoaded", function(event) {

    var universes_exists = !!$("#top-universes").length;
    var secondary_exists = !!$("#secondary_bar").length;
    if (universes_exists && secondary_exists){
      $("#MainContent").css("margin-top","40px");
    }

    window.onscroll = function() {
      try{
        var height = document.getElementById('site-header').offsetHeight;
        //1. Hide or Show Universes bar
        if ( window.pageYOffset > height+200 ) {
          $("#top-universes").fadeOut();
          //$("#secondary_bar").fadeOut();
        } else {
          $("#top-universes").fadeIn();
          //$("#secondary_bar").fadeIn();
        }
        
        //2. Switch background color
        if (!!shop_template && shop_template === "index"){
          if ( window.pageYOffset > height+200 ) {
            switchHeaderWhite();
          } else {
            switchHeaderTransparent();
          }
        }
      }
      catch(e){
        
      }
    }


    
    if (!!shop_template && shop_template === "index"){
      $('#menu1').hover(switchHeaderWhite, switchHeaderTransparent);
    }
    
    var header = document.getElementById('site-header');
    var main = document.getElementById('MainContent');
    var headerHeight = header.offsetHeight;
    document.getElementById('MainContent').style.setProperty('--header-height', '-'+ headerHeight + 'px');

    document.getElementById("header-menu").addEventListener('click',function () {
      var sideMenu = document.getElementById('Details-menu-drawer-container');
      var height = header.offsetHeight;
      if ( window.pageYOffset < height ) {
      if (!sideMenu.classList.contains('menu-opening')) {
        header.classList.remove('site-header-transparent');
      } else {
        header.classList.add('site-header-transparent');
      }
      }
    });

    let itemsContainer = document.querySelector(".header__inline-menu");
    if (!!itemsContainer){
      try{
        let items = itemsContainer.querySelectorAll("details");
        items.forEach(item => {
          item.addEventListener("mouseover", () => {
            item.setAttribute("open", true);
            item.querySelector("ul").addEventListener("mouseleave", () => {
              item.removeAttribute("open");
            });
            item.addEventListener("mouseleave", () => {
              item.removeAttribute("open");
            });
          });
        
        });
      }catch(e){
        console.log(e);
      }
    }




    document.querySelectorAll('.ayaq-li-menu1').forEach(function(menuItem) {
      const submenu = menuItem.querySelector('.ayaq-submenu-container');

      // Gérer l'affichage du sous-menu au survol
      menuItem.addEventListener('mouseenter', function() {
        closeAllSubmenus(); // Fermer tous les autres sous-menus
        if (submenu) {
          submenu.classList.add('open'); // Ouvrir le sous-menu de cet élément
        }
      });

      // Gérer la fermeture du sous-menu quand la souris quitte
      menuItem.addEventListener('mouseleave', function() {
        if (submenu) {
          submenu.classList.remove('open'); // Fermer le sous-menu du menu quitté
        }
      });
    });

    // Fonction pour fermer tous les sous-menus
    function closeAllSubmenus() {
      document.querySelectorAll('.ayaq-submenu-container.open').forEach(function(openSubmenu) {
        openSubmenu.classList.remove('open'); // Fermer tous les sous-menus ouverts
      });
    }

    // Fermer le sous-menu quand la souris va sur ayaq-submenu-media
    document.querySelectorAll('.ayaq-submenu-media').forEach(function(media) {
      media.addEventListener('mouseenter', function() {
        closeAllSubmenus();
      });
    });

    // ========================================
    // Menu Image Hover: Update image, text overlay, and links on collection hover
    // ========================================
    const editorialRequests = new Map();
    const initializedImageMenus = new WeakSet();

    function readMenuEditorial(root, handle) {
      for (const script of root.querySelectorAll('[data-ayaq-menu-editorial]')) {
        try {
          const data = JSON.parse(script.textContent);
          if (data.handle === handle) return data;
        } catch { /* Ignore malformed or unrelated section data. */ }
      }
      return null;
    }

    function loadMenuEditorial(link) {
      const handle = link.dataset.collectionHandle;
      const local = readMenuEditorial(document, handle);
      if (local) return Promise.resolve(local.media);
      const url = new URL(link.href, window.location.href);
      if (url.origin !== window.location.origin) return Promise.resolve(null);
      url.search = '';
      url.hash = '';
      // Keep requests on the preview theme, including from the Theme Editor.
      if (window.Shopify?.theme?.role === 'unpublished' || window.Shopify?.theme?.role === 'development') {
        url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
      }
      const key = url.href;
      if (!editorialRequests.has(key)) {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 6000);
        const request = fetch(url, { signal: controller.signal, credentials: 'same-origin', priority: 'low' })
          .then(response => {
            if (!response.ok) throw new Error('Collection unavailable');
            return response.text();
          })
          .then(html => {
            // Template contents remain inert: no page scripts or images execute/load.
            const template = document.createElement('template');
            template.innerHTML = html;
            return readMenuEditorial(template.content, handle)?.media || null;
          })
          .catch(() => {
            editorialRequests.delete(key);
            return null;
          })
          .finally(() => clearTimeout(timeout));
        editorialRequests.set(key, request);
      }
      return editorialRequests.get(key);
    }

    function initMenuImageHover() {
      const experienceMediaMap = window.collectionExperienceMedia || {};

      document.querySelectorAll('.ayaq-submenu-container').forEach(function(submenu) {
        if (initializedImageMenus.has(submenu)) return;
        const imageColumn = submenu.querySelector('.ayaq-menu-image-column');
        if (!imageColumn) return;

        const card = imageColumn.querySelector('.ayaq-menu-card');
        const image = imageColumn.querySelector('.ayaq-menu-hover-image');
        const cardLink = imageColumn.querySelector('.ayaq-menu-card__link');
        const overlayText = imageColumn.querySelector('.ayaq-menu-card__overlay-text');
        const textContent = imageColumn.querySelector('.ayaq-menu-card__text-content');

        if (!image || !card) return;
        initializedImageMenus.add(submenu);
        const defaultAlt = image.alt;
        const defaultLabel = cardLink?.getAttribute('aria-label');
        let activePreview;
        let previewTimer;

        // Helper to update orientation class
        function updateCardOrientation(isPortrait) {
          if (isPortrait) {
            card.classList.add('ayaq-menu-card--portrait');
            card.classList.remove('ayaq-menu-card--landscape');
          } else {
            card.classList.add('ayaq-menu-card--landscape');
            card.classList.remove('ayaq-menu-card--portrait');
          }
        }

        // Helper to set position class on overlay
        function updateOverlayPosition(positionClass) {
          if (!overlayText) return;
          const pos = positionClass || card.dataset.defaultPosition || 'center';
          const positions = [
            'center',
            'top-left',
            'top-center',
            'top-right',
            'bottom-left',
            'bottom-center',
            'bottom-right'
          ];
          for (const p of positions) {
            overlayText.classList.remove('ayaq-menu-card__overlay-text--' + p);
          }
          overlayText.classList.add('ayaq-menu-card__overlay-text--' + pos);
        }

        // Auto-detect image natural aspect ratio once loaded if needed
        image.addEventListener('load', function() {
          if (image.naturalWidth && image.naturalHeight) {
            const isNaturalPortrait = image.naturalHeight > image.naturalWidth;
            updateCardOrientation(isNaturalPortrait);
          }
        });

        // Find all links with collection handles within this submenu
        const links = submenu.querySelectorAll('a[data-collection-handle]');

        links.forEach(function(link) {
          async function showCollectionImage() {
            const handle = link.dataset.collectionHandle;
            if (!handle) return;
            const request = {};
            activePreview = request;
            let data = await loadMenuEditorial(link) || experienceMediaMap[handle];
            if (activePreview !== request || !submenu.isConnected) return;
            if (!data) return;
            if (typeof data === 'string') {
              data = { imageUrl: data };
            }

            // Keep the previous visual until its replacement is ready.
            if (data.imageUrl) {
              const nextImage = new Image();
              nextImage.sizes = image.sizes;
              nextImage.srcset = data.srcset || '';
              nextImage.src = data.imageUrl;
              try { await nextImage.decode(); } catch { return; }
              if (activePreview !== request || !submenu.isConnected) return;
            }

            // 1. Update image src & srcset
            if (data.imageUrl) {
              image.src = data.imageUrl;
              if (data.srcset) {
                image.srcset = data.srcset;
              } else {
                image.srcset = data.imageUrl;
              }
            }

            if (data.alt) {
              image.alt = data.alt;
              if (cardLink) cardLink.setAttribute('aria-label', data.alt);
            }
            image.style.objectPosition = data.objectPosition || '';

            // 2. Update orientation (portrait vs landscape)
            if (typeof data.isPortrait === 'boolean') {
              updateCardOrientation(data.isPortrait);
            } else if (data.aspectRatio) {
              updateCardOrientation(data.aspectRatio < 1);
            }

            // 3. Update Text overlay
            if (overlayText && textContent) {
              if (data.text && data.text.trim() !== '') {
                textContent.textContent = data.text;
                overlayText.classList.remove('ayaq-menu-card__overlay-text--hidden');

                if (data.textColor) {
                  overlayText.style.setProperty('--experience-text-color', data.textColor);
                } else {
                  overlayText.style.removeProperty('--experience-text-color');
                }

                if (data.textSize) {
                  const textSizeStr = String(data.textSize);
                  const sizeVal = (textSizeStr.includes('px') || textSizeStr.includes('rem')) ? textSizeStr : textSizeStr + 'px';
                  overlayText.style.setProperty('--experience-text-size', sizeVal);
                } else {
                  overlayText.style.removeProperty('--experience-text-size');
                }

                updateOverlayPosition(data.textPosition);
              } else {
                overlayText.classList.add('ayaq-menu-card__overlay-text--hidden');
                textContent.textContent = '';
              }
            }

            // 4. Editorials link to their collection; legacy media keep their configured links.
            if (cardLink) {
              let targetUrl = '';
              // Check string link
              if (typeof data.link === 'string' && data.link.trim() !== '') {
                targetUrl = data.link.trim();
              } else if (data.link && typeof data.link === 'object') {
                targetUrl = (data.link.url || data.link.href || '').trim();
              }

              // Check rawLinks if string was empty
              if (!targetUrl && data.rawLinks) {
                if (Array.isArray(data.rawLinks) && data.rawLinks.length > 0) {
                  const first = data.rawLinks[0];
                  targetUrl = typeof first === 'string' ? first.trim() : (first && (first.url || first.href) ? (first.url || first.href).trim() : '');
                } else if (typeof data.rawLinks === 'object') {
                  targetUrl = (data.rawLinks.url || data.rawLinks.href || '').trim();
                } else if (typeof data.rawLinks === 'string') {
                  targetUrl = data.rawLinks.trim();
                }
              }

              if (targetUrl) {
                cardLink.setAttribute('href', targetUrl);
                cardLink.classList.remove('ayaq-menu-card__link--disabled');
                cardLink.removeAttribute('role');
                cardLink.removeAttribute('tabindex');
                card.style.cursor = 'pointer';
                cardLink.style.pointerEvents = 'auto';
              } else {
                cardLink.removeAttribute('href');
                cardLink.classList.add('ayaq-menu-card__link--disabled');
                cardLink.setAttribute('role', 'presentation');
                cardLink.setAttribute('tabindex', '-1');
                card.style.cursor = 'default';
                cardLink.style.pointerEvents = 'none';
              }
            }
          }
          link.addEventListener('mouseenter', function() {
            activePreview = null;
            clearTimeout(previewTimer);
            previewTimer = setTimeout(showCollectionImage, 120);
          });
          link.addEventListener('mouseleave', function() {
            clearTimeout(previewTimer);
          });
          link.addEventListener('focus', function() {
            clearTimeout(previewTimer);
            showCollectionImage();
          });
        });

        // Reset to default illustration/link when mouse leaves the submenu
        submenu.addEventListener('mouseleave', function() {
          clearTimeout(previewTimer);
          activePreview = null;
          image.alt = defaultAlt;
          image.style.removeProperty('object-position');
          if (cardLink) {
            if (defaultLabel) cardLink.setAttribute('aria-label', defaultLabel);
            else cardLink.removeAttribute('aria-label');
          }
          if (card.dataset.defaultImage && image) {
            image.src = card.dataset.defaultImage;
            if (card.dataset.defaultSrcset) {
              image.srcset = card.dataset.defaultSrcset;
            }
          }
          if (card.dataset.defaultPortrait !== undefined) {
            updateCardOrientation(card.dataset.defaultPortrait === 'true');
          }
          if (overlayText && textContent) {
            if (card.dataset.defaultText && card.dataset.defaultText.trim() !== '') {
              textContent.textContent = card.dataset.defaultText;
              overlayText.classList.remove('ayaq-menu-card__overlay-text--hidden');
              if (card.dataset.defaultTextColor) {
                overlayText.style.setProperty('--experience-text-color', card.dataset.defaultTextColor);
              }
              if (card.dataset.defaultTextSize) {
                overlayText.style.setProperty('--experience-text-size', card.dataset.defaultTextSize);
              }
              updateOverlayPosition(card.dataset.defaultPosition);
            } else {
              overlayText.classList.add('ayaq-menu-card__overlay-text--hidden');
              textContent.textContent = '';
            }
          }
          if (cardLink) {
            const defLink = card.dataset.defaultLink;
            if (defLink && defLink.trim() !== '') {
              cardLink.setAttribute('href', defLink.trim());
              cardLink.classList.remove('ayaq-menu-card__link--disabled');
              cardLink.removeAttribute('role');
              cardLink.removeAttribute('tabindex');
              cardLink.style.pointerEvents = 'auto';
              card.style.cursor = 'pointer';
            } else {
              cardLink.removeAttribute('href');
              cardLink.classList.add('ayaq-menu-card__link--disabled');
              cardLink.setAttribute('role', 'presentation');
              cardLink.setAttribute('tabindex', '-1');
              cardLink.style.pointerEvents = 'none';
              card.style.cursor = 'default';
            }
          }
        });

        // Ensure click on card or image triggers link navigation
        if (!card.dataset.hasClickListener) {
          card.dataset.hasClickListener = 'true';
          card.addEventListener('click', function(e) {
            const currentLink = card.querySelector('.ayaq-menu-card__link');
            const href = currentLink ? currentLink.getAttribute('href') : null;
            if (href && href.trim() !== '' && href !== '#') {
              window.location.href = href;
            }
          });
        }
      });
    }

    // Initialize menu image hover after DOM is ready
    initMenuImageHover();
    document.addEventListener('shopify:section:load', function() {
      editorialRequests.clear();
      initMenuImageHover();
    });


    customElements.define('sticky-header', StickyHeader);
    
  });


class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      if (!this || !this.header) return;
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      if (!this || !this.header) return;
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      if (!this || !this.header) return;
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {return;
      if (!this || !this.header || !this.predictiveSearch || !this.currentScrollTop || !this.headerBounds) return;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      //this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      if (!this || !this.header) return;
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (!this || !this.header || !this.header.classList) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (!this || !this.header || !this.header.classList) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      if (!this || !this.header) return;
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      if (!this.disclosures) return;
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      if (!this || !this.header) return;
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }
